import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { mdlGetMailContentRequest } from '../../models/service-models/mail/GetMailContentRequest';
import { MailService } from '../../services/MailService';
import { t } from 'i18next';
import { Button, Skeleton, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

const MyMail = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("Id") || searchParams.get("id");

    const {
        data,
        isLoading,
        isError,
        isFetched,
        refetch: getMailContent,
    } = useQuery(
        ["getMailContent", id],
        () => {
            if (id) {
                const request: mdlGetMailContentRequest = { id: id };
                return MailService.GetMailContent(request);
            }
        },
        {
            staleTime: 0,
            refetchOnWindowFocus: false,
            enabled: !!id,
        }
    );

    const handlePrint = () => {
        window.print();
    };

    return (
        <div>
            {isLoading ? <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
            </> : <><div dangerouslySetInnerHTML={{ __html: data?.body?.data?.text || t("mail.failedToLoadMailContent") }} />
                {isFetched && data?.body?.data?.text && (
                    <div className="d-flex justify-content-center m-3 ">
                        <Button className=' print-button btn btn-primary' onClick={handlePrint}><FontAwesomeIcon icon={faPrint} /> {t("common.print")}</Button>
                    </div>
                )}</>}
        </div>
    );
};

export default MyMail;
